import { Link } from 'react-router-dom';
import { Check, Lock } from 'lucide-react';
import { statusLabel } from './StageTabs';

const card = 'block rounded-2xl bg-white border p-6 transition-[border-color,transform] duration-200';

export const StageNavigator = ({ bid, stages, status }) => (
  <ol className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="founder-stage-navigator">
    {stages.map((s) => {
      const st = status?.[s.key] || 'not_started';
      const body = (
        <>
          <div className="flex items-center justify-between">
            <span className="font-serif-display italic text-gold text-2xl">{s.number}</span>
            <span className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-[10px] uppercase tracking-[0.2em] ${st === 'complete' ? 'bg-gold/15 text-matte' : 'bg-matte/5 text-matte/60'}`} data-testid={`founder-stage-${s.key}-status`}>
              {!s.available ? <><Lock size={10} /> Coming soon</> : <>{st === 'complete' && <Check size={10} />} {statusLabel(st)}</>}
            </span>
          </div>
          <div className="mt-4 text-[11px] uppercase tracking-[0.28em] text-matte">{s.name}</div>
          <div className="mt-1 text-sm text-matte/60">{s.subtitle}</div>
        </>
      );
      return (
        <li key={s.key} data-testid={`founder-stage-${s.key}`}>
          {s.available ? (
            <Link to={`/founder/blueprint/${bid}/${s.key}`} className={`${card} border-matte/10 hover:border-gold hover:-translate-y-0.5`} data-testid={`founder-stage-${s.key}-link`}>{body}</Link>
          ) : (
            <div aria-disabled="true" className={`${card} border-dashed border-matte/15 opacity-70`}>{body}</div>
          )}
        </li>
      );
    })}
  </ol>
);
